export class SalesUser {
  name: string;
  info: string;
  adress: string;
  city: string;
  postalcode: string;
  phone: string;
  email: string;
  locationName: string;
  isExpanded = false;
}

export interface SalesUsers { }

export enum regionEnum {
  UK = 'UK',
  TX = 'TX',
  ZA = "ZA",
  Selected = "Selected"
}

export interface NavLinks {
  label: string;
  path: string;
  isActive: false;
  children?: SubHeaderLinks[];
}

export enum Sidenavs {
  menu,
  product
}

export interface SubHeaderLinks {
  label: string;
  path: string;
}

export enum MetaPageEnum {
  Home = 'Home',
  OurStock = 'OurStock',
  Services = 'Services',
  ServicesVolvoSelected = 'ServicesVolvoSelected',
  ServicesFinancing = 'ServicesFinancing',
  TruckModels = 'TruckModels',
  TruckModelsFH16 = 'TruckModelsFH16',
  TruckModelsFH = 'TruckModelsFH',
  TruckModelsFM = 'TruckModelsFM',
  TruckModelsFMX = 'TruckModelsFMX',
  TruckModelsFE = 'TruckModelsFE',
  TruckModelsFL = 'TruckModelsFL',
  TruckModelsFH16_Selected = 'TruckModelsFH16_Selected',
  TruckModelsFH_Selected = 'TruckModelsFH_Selected',
  TruckModelsFM_Selected = 'TruckModelsFM_Selected',
  TruckModelsFMX_Selected = 'TruckModelsFMX_Selected',
  BuyersGuide = 'BuyersGuide',
  AboutUs = 'AboutUs',
  ContactUs = 'ContactUs',
  TruckPage = 'TruckPage',
  WhatCustomersSay = 'WhatCustomersSay',
  WhatWeHave = 'WhatWeHave',
  WhatWhoWeAre = 'WhatWhoWeAre',
  CentreBanbury = 'CentreBanbury',
  CentreEly = 'CentreEly',
  CentreBardon = 'CentreBardon',
  CentreEnfield = 'CentreEnfield',
  CentreFelixstowe = 'CentreFelixstowe',
  CentreGlasgowWest = 'CentreGlasgowWest',
  CentreHayes = 'CentreHayes',
  CentreReading = 'CentreReading',
  CentreWashington = 'CentreWashington',
  CentreWellingborough = 'CentreWellingborough',
  CentreEdinburgh = 'CentreEdinburgh',
  CustomisationPage = 'CustomisationPage',
  ServicesContract = 'ServicesContract',
  FinancingPage = 'FinancingPage',
  VolvoSelectedFAQ = 'VolvoSelectedFAQ',
  VolvoConnectPage = 'VolvoConnectPage',
  ServiceEconomyPage = 'ServiceEconomyPage',
  VolvoExportPage = 'VolvoExportPage',
  VolvoSelectedPage = 'VolvoSelectedPage',
  UTCustomisationPage = 'UTCustomisationPage',
  EconomyFAQPage = 'EconomyFAQPage',
  UnsubscribePage = 'UnsubscribePage',
  VehicleOfferRemainingWarranty = 'VehicleOfferRemainingWarranty',
  VehicleOfferVolvoApproved = 'VehicleOfferVolvoApproved',
  VehicleOfferVolvoEconomy = 'VehicleOfferVolvoEconomy',
}

export enum ServiceHistoryType {
  GOLD = 'gold',
  SILVER = 'silver',
  BLUE = 'blue',
  SERVICE_RECORD_AVAILABLE = 'service record available'
}
